<template>
  <div class="part-inventory-unstock">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- <el-form-item style="float: right;">
          <el-button class="table-set" style="vertical-align: top;" @click="exportTable('partExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item> -->
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('dms_part_inventory_unstock.ljbhljSNljmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_part_inventory_unstock.zhi_bao_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.warrantyDate" type="daterange" :picker-options="pickerOption"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_unstock.ISTzhan_dian')">
          <custom-select
            @change="websiteNameChange"
            v-model="formSearch.websiteName"
            filterable
            url="websiteSelectList"
            :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
            :model="formSearch"
            :props="{ label: 'websiteName', value: 'websiteName', map: { websiteCode: 'websiteCode' } }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_unstock.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :listener="formSearch.websiteCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :params="{ websiteCode: formSearch.websiteCode }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_unstock.fa_wang_guo_jia')" prop="country">
          <custom-select url="factoryDeliveryPlaceSelectList" v-model="formSearch.country" :props="{ label: 'placeName', value: 'placeName' }"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_unstock.fa_wang_zong_bu')" prop="outHqName">
          <el-input v-model="formSearch.outHqName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_unstock.chu_ku_dan_hao')">
          <el-input v-model="formSearch.shipmentNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_unstock.chu_ku_shi_jian')">
          <custom-date-picker
            style="vertical-align: top"
            v-model="formSearch.outTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="——"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOption"
            :start-placeholder="$t('dms_part_inventory_unstock.kai_shi_shi_jian')"
            :end-placeholder="$t('dms_part_inventory_unstock.jie_shu_shi_jian')"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_unstock.ji_shen_hao')">
          <el-input v-model="formSearch.bodyNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_unstock.ling_jian_wei_zhi')">
          <el-input v-model="formSearch.componentCode"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table index :column="tableColumn" :data="tableList" @filter="filterChange" @sort="sortChange" height="100%" :slots="['action']" v-model="tableSelect">
        <!-- <template v-slot:partCode="scope" >
          <div class="cell-link" @click="watchEvent(scope.row)">{{ scope.row.partCode }}</div>
        </template> -->
        <template v-slot:action="scope">
          <!-- 新零件才显示：新增，编辑 -->
          <span v-if="`${scope.row.partState}` === '1'">
            <el-button type="text" size="mini" @click="editEvent(scope.row)" v-if="funcView.parts_inventory_edit">{{ funcView.parts_inventory_edit }}</el-button>
            <el-button type="text" size="mini" @click="deleteEvent(scope.row)" v-if="funcView.parts_inventory_delete">{{ funcView.parts_inventory_delete }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <part-inventory-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></part-inventory-dialog>
    <part-inventoryEdit-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onPageChange({ page: 1 })"></part-inventoryEdit-dialog>
    <part-inventory-batch-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="onPageChange({ page: 1 })"></part-inventory-batch-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import partInventoryDialog from './part_inventory_dialog.vue';
import partInventoryEditDialog from './part_inventoryEdit_dialog.vue';
import partInventoryBatchDialog from './part_inventory_batch_dialog.vue';

export default {
  name: '',
  mixins: [resetFormSearchMixins],
  components: { partInventoryDialog, partInventoryEditDialog, partInventoryBatchDialog },
  props: {},
  data() {
    return {
      tableCode: 'part_inventory_unstock',
      formSearch: {
        search: '',
        partType: '',
        replaceMethod: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        dataTimes: [],
        componentCode: '',
        bodyNum: '',
        country: '',
        websiteName: '',
        inBatchNum: '',
        warrantyDate: [],
        stockState: 3,
        shipmentNum: '',
        outTime: [],
        productCode: '',
        outHqName: '',
      },

      tableSelect: [],
      tableList: [],
      totalRows: null,
      // 新增
      dialogVisible: false,
      dialogModel: {},
      // 编辑
      dialogVisible1: false,
      dialogModel1: {},
      // 入库
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    websiteNameChange() {
      this.formSearch.productCode = '';
    },
    // 新增
    addEvent: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('dms_part_inventory_unstock.tian_jia_ling_jian');
      this.dialogVisible = true;
    },
    // 编辑
    editEvent: function (data) {
      this.dialogModel1.type = 'edit';
      this.dialogModel1.title = this.$t('dms_part_inventory_unstock.bian_ji_ling_jian');
      this.dialogModel1.data = data;
      this.dialogVisible1 = true;
    },

    addBatchPart: function () {
      this.dialogVisible2 = true;
    },
    // 删除
    deleteEvent: function (data) {
      this.$showConfirm(this.$t('dms_part_inventory_unstock.nqrscljSNwodljm', [data.partSn]))
        .then(() => {
          this.$postJSON(`${apis.partStockDelete}/${data.stockFactoryId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.inTimeStart = this.formSearch.dataTimes ? this.formSearch.dataTimes[0] : '';
      this.formSearch.inTimeEnd = this.formSearch.dataTimes ? this.formSearch.dataTimes[1] : '';
      this.formSearch.warrantyDateStart = this.formSearch.warrantyDate ? this.formSearch.warrantyDate[0] : '';
      this.formSearch.warrantyDateEnd = this.formSearch.warrantyDate ? this.formSearch.warrantyDate[1] : '';
      this.formSearch.outStartTime = this.formSearch.outTime ? this.formSearch.outTime[0] : '';
      this.formSearch.outEndTime = this.formSearch.outTime ? this.formSearch.outTime[1] : '';

      const reqData = {
        ...this.formSearch,
      };

      delete reqData.dataTimes;
      delete reqData.warrantyDate;
      delete reqData.outTime;

      this.$getJSON(apis.partStockPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },

    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
  created() {},
  mounted() {
    this.getTableList();
    this.getTableColumn();
    this.getFuncView();
  },
};
</script>

<style lang="scss">
.part-inventory-unstock {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  overflow: hidden;
}
</style>
